import { withProps } from 'react-recompose';
import Success from '../../components/SuccessPage/SuccessPage';
import theme from '../../config/themes/kaizen/index';
import { resetToDashboard } from '../../modules/Navigation/actions';
import I18n from '../../lib/i18n';

const withSuccessProps = () => ({
  pageTestID: 'paymentSuccess-screen',
  confirmButtonText: I18n.t('Dashboard.AddMoneyWithCreditCard.successPage.buttonText'),
  successTitle: I18n.t('Dashboard.AddMoneyWithCreditCard.successPage.body'),
  successImage: theme.successPhoneImage,
  confirmButtonAction: resetToDashboard,
});

export default withProps(withSuccessProps)(Success);
